/**
 * Convert a Date to an ISO date string.
 * @param date Date to convert
 * @return Date as string in "YYYY-MM-DD" format.
 */
export function isoDateString(date: Date): string {
    let result = date.getFullYear() + "-";

    // API of the year, #1: Month is zero-based
    let month = date.getMonth() + 1;
    if (month < 10) {
        result += "0";
    }
    result += month + "-";

    // API of the year, #2: "getDate()" returns _day_ of the month (and is not zero-based)
    let day = date.getDate();
    if (day < 10) {
        result += "0";
    }
    result += day;

    return result;
}